<div class="modal right" id="workerDetail" tabindex="-1" role="dialog" aria-labelledby="workerDetailLabel">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content" id="print-content">
			<div class="modal-header hide-print">
				<div class="modal-title">
					<h4 id="workerDetailLabel">Driver Detail</h4>
				</div>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<i class="icon-close-circle"></i>
				</button>
			</div>

			<div class="modal-body order-detail-page">
				<ul class="nav nav-tabs nav-justified" id="tabContent">
					<li class="active">
						<a target="_self" href="#details" data-toggle="tab">Details</a>
					</li>
					<li>
						<a target="_self" href="#documents" data-toggle="tab">
							ID <span class="label label-primary">{{ worker.documents.length }}</span>
						</a>
					</li>
					<li>
						<a target="_self" href="#w9" data-toggle="tab">
							W9 
						</a>
					</li>
					<li>
						<a target="_blank" href="/earning?worker_id={{worker.id}}&summary=true">
							Earnings 
						</a>
					</li>
					<li>
						<a target="_blank" href="/routes?worker_id={{worker.id}}">
							Routes <span class="label label-primary">{{ worker.route_count }}</span>
						</a>
					</li>
				</ul>

				<div class="tab-content">
					<div class="tab-pane active" id="details">
						<div class="modal-body-container">
							<div class="row">
								<div class="col-md-9">
									<div class="row">
										<div class="col-md-6 mt-2">
											<div class="panel mb-10">
												<p>
													<strong>Full Name </strong>
													<span>
														<img ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ worker.profile_photo }}" 
														class="img-responsive text-center img-circle" 
														width="36px" 
														height="36px" 
														style="width:36px; height:36px;" >
														{{ worker.user.full_name }}
													</span>
												</p>
												<p>
													<strong>Email</strong>
													<span>
														{{ worker.user.email }}
													</span>
												</p>
												<p>
													<strong>Phone Number </strong>
													<span>
														{{ worker.phone_number }}
													</span>
												</p>
												<p>
													<strong>ID (Passport Or Driving Licence) </strong>
													<span>
														{{ worker.identification_number.length > 0 ? worker.identification_number : '-' }}
													</span>
												</p>
												<p>
													<strong>Created At</strong>
													<span>
														{{ worker.created_at | amUtc | amDateFormat:'MM/DD/YYYY, HH:mm' }}
													</span>
												</p>
												<p>
													<strong>Dispatcher </strong>
													<span>
														{{ worker.dispatcher ? 'Yes' : 'No' }}
													</span>
													<span ng-if="worker.dispatcher">Stations</span>
													<p ng-repeat="item in worker.stations" ng-if="worker.dispatcher">{{ item.code }}</p>
												</p>
											</div>
										</div>
										<div class="col-md-6 mt-2">
											<div class="panel mb-10">
												<p>
													<strong>Street </strong>
													<span>
														{{ worker.address }} {{ worker.address2 }}
													</span>
												</p>
												<p>
													<strong>City</strong>
													<span>
														{{ worker.city }}
													</span>
												</p>
												<p>
													<strong>State </strong>
													<span>
														{{ worker.state }}
													</span>
												</p>
												<p>
													<strong>Zipcode </strong>
													<span>
														{{ worker.zipcode }}
													</span>
												</p>
												<p>
													<strong>Offer Stations </strong>
													<p ng-repeat="item in worker.offer_stations">{{ item.code }}</p>
													<p ng-if="worker.offer_stations.length == 0"> Station Not Found</p>
												</p>
											</div>
										</div>
										<div class="col-md-6 mt-2">
											<div class="panel mb-10">
												<p>
													<strong>Vehicle Type </strong>
													<span>
														{{ worker.vehicle.length > 0 ? worker.vehicle : '-' }}
													</span>
												</p>
												<p>
													<strong>Vehicle Year </strong>
													<span>
														{{ worker.vehicle_year.length > 0 ? worker.vehicle_year : '-' }}
													</span>
												</p>
												<p>
													<strong>Vehicle Make</strong>
													<span>
														{{ worker.vehicle_make.length > 0 ? worker.vehicle_make : '-' }}
													</span>
												</p>
												<p>
													<strong>Vehicle Model </strong>
													<span>
														{{ worker.vehicle_model.length > 0 ? worker.vehicle_model : '-' }}
													</span>
												</p>
												<!-- <p>
													<strong>Plate Number </strong>
													<span>
														{{ worker.number_plate.length > 0 ? worker.number_plate : '-' }}
													</span>
												</p> -->
											</div>
										</div>
										<div class="col-md-6 mt-2">
											<div class="panel mb-10">
												<p>
													<strong>Account Holder Name </strong>
													<span>
														{{ worker.account_holder_name.length > 0 ? worker.account_holder_name : '-' }}
													</span>
												</p>
												<p>
													<strong>Routing Number </strong>
													<span>
														{{ worker.routing_number.length > 0 ? worker.routing_number : '-' }}
													</span>
												</p>
												<p>
													<strong>Account Number</strong>
													<span>
														{{ worker.account_number.length > 0 ? worker.account_number : '-' }}
													</span>
												</p>
											</div>
										</div>
									</div>
								</div>

								<div class="col-md-3 pt-4">
									<a href="#" class="hod-button mb-2 btn-block blue" ng-click="chageUserStatus(0)"
										ng-if="worker.user.status == 1">
										Approve
									</a>
									<a href="#" class="hod-button mb-2 btn-block blue" ng-click="chageUserStatus(1)"
										ng-if="worker.user.status == 0">
										Remove Approve
									</a>

									<a href="#" class="hod-button mb-2 btn-block blue" ng-click="chageWorkerStatus(1)"
										ng-if="worker.status == 0">
										Switch to Online
									</a>
									<a href="#" class="hod-button mb-2 btn-block blue" ng-click="chageWorkerStatus(0)"
										ng-if="worker.status == 1">
										Switch to Offline
									</a>

									<a href="#" class="hod-button mb-2 btn-block blue" ng-click="updateWorkerField('backgroud_check', 1)"
										ng-if="!worker.backgroud_check">
										Complete Back. Check
									</a>

									<a href="#" class="hod-button mb-2 btn-block blue" ng-click="updateWorkerField('id_verification', 1)"
										ng-if="!worker.id_verification">
										Confirm Identity
									</a>

									<a href="#" class="hod-button mb-2 btn-block blue" ng-click="chageWorkerRouteStatus(1)"
										ng-if="worker.route_status == 0">
										Make Arrived
									</a>

									<a 
										href="#" 
										ng-click="printWorker(worker.id)" 
										class="btn btn-block mb15">
										Print
									</a>

									<a 
										href="#" 
										ng-if="can('maps')"
										ng-click="editData(worker.id)"
										class="hod-button mb-2 btn-block orange">
										Edit
									</a>

									<a 
										href="#" 
										ng-if="can('maps')"
										ng-click="callDriver(worker.id)"
										class="hod-button mb-2 btn-block">
										<span ng-if="!loading">Call Driver</span>
										<span ng-if="loading">Calling Driver...</span>
									</a>
									<!-- <a 
										href="calisan-yonetimi/detay/{{ worker.id }}/duzenle" 
										ng-if="can('maps')"
										ng-click="newData()"
										class="hod-button blue ml-2">
										Edit
									</a> -->
								</div>

							</div>
						</div>
					</div>

					<!-- <div class="tab-pane" id="activity">
						<div class="row mt15">
							<div class="col-md-12">
								<div class="panel mb10">
									<table class="table table-hover tc-checkbox-1 fs13" ng-if="worker.orders.length > 0">
										<thead>
											<tr class="bg-light">
												<th>
													<a href="#" ng-click="sortType = 'id'; sortReverse = !sortReverse">
													NO
													<span ng-show="sortType == 'id' && !sortReverse" class="fa fa-caret-down"></span>
													<span ng-show="sortType == 'id' && sortReverse" class="fa fa-caret-up"></span>
													</a>
												</th>
												<th>
													<a href="#" ng-click="sortType = 'worker.customer.customer_name'; sortReverse = !sortReverse">
													Müşteri Bilgileri
													<span ng-show="sortType == 'worker.customer.customer_name' && !sortReverse" class="fa fa-caret-down"></span>
													<span ng-show="sortType == 'worker.customer.customer_name' && sortReverse" class="fa fa-caret-up"></span>
													</a>
												</th>
												<th>
													<a href="#" ng-click="sortType = 'time'; sortReverse = !sortReverse">
													Teslim Süresi
													<span ng-show="sortType == 'time' && !sortReverse" class="fa fa-caret-down"></span>
													<span ng-show="sortType == 'time' && sortReverse" class="fa fa-caret-up"></span>
													</a>
												</th>
												<th>
													<a href="#" ng-click="sortType = 'created_at'; sortReverse = !sortReverse">
													Kayıt Tarihi
													<span ng-show="sortType == 'created_at' && !sortReverse" class="fa fa-caret-down"></span>
													<span ng-show="sortType == 'created_at' && sortReverse" class="fa fa-caret-up"></span>
													</a>
												</th>
												<th>
													<a href="#" ng-click="sortType = 'scheduled_time'; sortReverse = !sortReverse">
													Kargo Tarihi
													<span ng-show="sortType == 'scheduled_time' && !sortReverse" class="fa fa-caret-down"></span>
													<span ng-show="sortType == 'scheduled_time' && sortReverse" class="fa fa-caret-up"></span>
													</a>
												</th>
												<th>
													<a href="#" ng-click="sortType = 'status'; sortReverse = !sortReverse">
													KargoDurumu
													<span ng-show="sortType == 'status' && !sortReverse" class="fa fa-caret-down"></span>
													<span ng-show="sortType == 'status' && sortReverse" class="fa fa-caret-up"></span>
													</a>
												</th>
											</tr>
										</thead>
										<tbody>
										<tr ng-repeat="item in worker.orders | orderBy:sortType:sortReverse">
											<td class="clickable-row text-left" ng-click="getworkerDetails(item)">{{ item.id }} </td>
											<td class="clickable-row" ng-click="getworkerDetails(item)">{{ item.customer.customer_name }} </td>
											<td class="clickable-row" ng-click="getOrderDetails(item)">{{ humanizeDuration(item.time) }}</td>
											<td class="clickable-row" ng-click="getOrderDetails(item)">{{ item.created_at | amDateFormat:'MM/DD/YYYY, HH:mm:ss' }}</td>
											<td class="clickable-row" ng-click="getOrderDetails(item)">{{ item.scheduled_time | amDateFormat:'MM/DD/YYYY, HH:mm:ss' }}</td>
											<td class="clickable-row" ng-click="getOrderDetails(item)">
												<span ng-if="item.status" ng-style="{'color': item.status.color }">{{ item.status.name }}</span>	
												<span ng-if="!item.status">Created</span>	
											</td>
										</tr>
										</tbody>
									</table>

									<div ng-if="worker.orders.length == 0">
										Bu çalışana ait bir iş henüz oluşturulmamıştır.
									</div>
								</div>
							</div>
						</div>
					</div> -->

					<div class="tab-pane" id="documents">
						<div class="modal-body-container">
							<div class="row allcp-form mt15">
								<div class="col-md-12">
									<div class="panel mb10">
										<table class="table table-hover tc-checkbox-1 fs13"
											ng-if="worker.documents.length > 0">
											<thead>
												<tr class="bg-light">
													<th class="text-center">Image</th>
													<th>Expired Date</th>
													<th></th>
												</tr>
											</thead>
											<tbody>
												<tr ng-repeat="item in worker.documents | orderBy:sortType:sortReverse">
													<td>
														<a href="https://s3.us-west-2.amazonaws.com/hodxpress/{{ item.name }}"
															target="__BLANK">
															<img class="center" height="90px"
																ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ item.name }}">
														</a>
														<br>
														<hr class="p5 m5">
														<span ng-if="item.type == 'driver_license_front'"> Driver
															Lincense Front</span>
														<span ng-if="item.type == 'driver_license_back'"> Driver
															Lincense Back</span>
														<span ng-if="item.type == 'insurance_photo'"> Insurance</span>
														<span ng-if="item.type == 'profile_photo'"> Profile Photo</span>
														<br>
														<span ng-if="item.status == 1"
															class="badge badge-success">Approved</span>
														<span ng-if="item.status == 0" class="badge badge-danger">Not
															Approved</span>
														<span ng-if="item.status == 2"
															class="badge badge-info">Pending</span>
														<br>
														<small>{{ item.created_at | amDateFormat:'DD/MM/YYYY, HH:mm' }}</small>
													</td>
													<td>
														<div class="row">
															<div class="col-md-6">
																<input id="datetimepicker" date-range-picker
																placeholder="Expired Date" type="text"
																class="form-control input-md" ng-model="item.expired_at"
																options="{ singleDatePicker: true, locale: { format: 'DD/MM/YYYY' } }"
																autocomplete="off" required>
															</div>
															<div class="col-md-6">
																<a href="#" class="btn btn-success btn-sm"
																	ng-click="chageDocumentField('expired_at', item.id, item.expired_at)"
																	ng-if="item.status">
																	Update
																</a>
															</div>
														</div>
													</td>
													<td>
														<a href="#" class="btn btn-success"
															ng-click="chageDocumentField('status', item.id, 1)"
															ng-if="!item.status">
															<i class="fa fa-check"></i> Approve
														</a>
														<a href="#" class="btn btn-warning"
															ng-click="chageDocumentField('status', item.id, 0)"
															ng-if="item.status">
															<i class="fa fa-close"></i> Remove Approval
														</a>
													</td>
												</tr>
											</tbody>
										</table>

										<div ng-if="worker.documents.length == 0">
											No documents.
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="tab-pane" id="w9">
						<div class="modal-body-container">
							<div class="row allcp-form mt15">
								<div class="col-md-12">
									<div class="fileupload fileupload-new" 
										data-provides="fileupload" 
										style="height: 300px;"
										ng-if="w9file">
										<div class="fileupload-preview thumbnail">
											<i ng-if="!worker.w9" class="fa fa-file fs24"></i>
											<div ng-if="worker.w9">
												<a class="fs21 center" 
													href="https://s3.us-west-2.amazonaws.com/hodxpress/{{ worker.w9.file }}"
													target="__BLANK">
												<i class="fa fa-file fs24"></i>
												{{ worker.w9.name }}
												</a>
												<hr>
											</div>
											<p>Drag file here</p>
											<div class="line-seperator">
												<div class="line"></div>
												<p>OR</p>
												<div class="line"></div>
											</div>
											<div class="logo_upload" ng-repeat="item in w9file.queue" style="width:50%">
												<div class="progress" ng-if="proccessProfile">
													<div 
														class="progress-bar progress-bar-success progress-bar-striped active" 
														role="progressbar" 
														aria-valuenow="60" 
														aria-valuemin="0" 
														aria-valuemax="100" 
														ng-style="{ 'width': item.progress + '%' }"
														>
													</div>
												</div>
											</div>
											<span class="btn btn-outline btn-file">
												<span class="fileupload-new">Select</span>
												<input type="file" nv-file-select uploader="w9file">
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>

	</div>
</div>
</div>